import type { IntelligenceFrame } from "@/features/intelligence/api/frames";
import type { InvalidatedEntity } from "@/shared/events/entity-invalidation";
import type { ThreadState } from "@/features/intelligence/lib/thread-state";

export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

export function inViewEntities(context: object | null | undefined): InvalidatedEntity[] {
  const raw = (context as { entities?: unknown } | null | undefined)?.entities;
  if (!Array.isArray(raw)) return [];
  const out: InvalidatedEntity[] = [];
  for (const entry of raw) {
    if (entry === null || typeof entry !== "object") continue;
    const { id, type } = entry as { id?: unknown; type?: unknown };
    if (typeof type !== "string" || type === "") continue;
    out.push({ id: typeof id === "string" ? id : "", type });
  }
  return out;
}

export function toolCallEndId(frame: IntelligenceFrame): string | null {
  if (frame.event !== "TOOL_CALL_END") return null;
  try {
    const data = JSON.parse(frame.data) as { toolCallId?: unknown };
    return typeof data.toolCallId === "string" && data.toolCallId !== "" ? data.toolCallId : null;
  } catch {
    return null;
  }
}

export function toolActivityFor(
  state: ThreadState,
  toolCallId: string,
): { toolName: string; argsText: string } | null {
  for (const node of state.nodes) {
    const tool = node.tools.find((candidate) => candidate.toolCallId === toolCallId);
    if (tool && tool.toolName !== "") {
      return { toolName: tool.toolName, argsText: tool.argsText };
    }
  }
  return null;
}

export function titleFromFirstMessage(text: string): string {
  const line = text.trim().replace(/\s+/g, " ");
  return line.length <= TITLE_MAX ? line : `${line.slice(0, TITLE_MAX - 1)}…`;
}

export function rememberRun(id: string, runId: string): void {
  try {
    sessionStorage.setItem(RUN_HANDLE_PREFIX + id, runId);
  } catch {}
}

export function recallRun(id: string): string | null {
  try {
    return sessionStorage.getItem(RUN_HANDLE_PREFIX + id);
  } catch {
    return null;
  }
}

export function forgetRun(id: string): void {
  try {
    sessionStorage.removeItem(RUN_HANDLE_PREFIX + id);
  } catch {}
}

const TITLE_MAX = 60;
const RUN_HANDLE_PREFIX = "simon.chat.live-run:";
